import { styled } from '@mui/material/styles';
import Tab, { TabProps } from '@mui/material/Tab';
import Tabs, { TabsProps } from '@mui/material/Tabs';

export const MprcRibbonTabs = styled((props: TabsProps) => (
    <Tabs
        {...props}
    />
))(({ theme }) => ({
    minHeight: 0,
    "& .MuiTabs-indicator": {
        display: "none",
    },
    "& .MuiTabs-scrollButtons.Mui-disabled": {
        display: "none"
    }
}));

export const MprcRibbonTab = styled((props: TabProps) => (
    <Tab
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    textTransform: "none",
    backgroundColor: theme.palette.paper.main,
    color: theme.palette.muted.main,
    borderRadius: theme.spacing(2),
    border: "1px",
    borderStyle: "solid",
    minWidth: 0,
    minHeight: 0,
    height: "30px",
    fontSize: "16px",
    fontWeight: "normal",
    whiteSpace: "nowrap",
    marginRight: theme.spacing(1),
    "&.Mui-selected": {
        backgroundColor: theme.palette.muted.main,
        color: theme.palette.common.white,
    },
}));
